<script>
</script>

<ul class="UIList">
	<slot />
</ul>

<style global>
	.UIList {
		display: flex;
		align-items: stretch;
		flex-wrap: wrap;
		margin: 0 -0.25em;
		padding: 0 0 2em 0;
	}
	:global(.pc) .UIList {
		margin: 0 -1.25em;
		padding: 2em 0;
	}
</style>
